import React, { useState } from "react";
import Header from "../components/common-web/Header";
import ResizablePanel from "../components/common/ResizablePanel";
import { SidebarCloseIcon, SidebarOpenIcon } from "../Icons";
import LineupSidebar from "../components/line-up/LineupSidebar";
import LineupContent from "../components/line-up/LineupContent";
import Checkbox from "../components/common/Checkbox";
import AnimatedPopup from "../components/common/AnimatedPopup";
import ProceduresPopup from "../components/line-up/ProceduresPopup";
import articleWhite from "../assets/icons/article-full-white.svg";

export default function Lineup() {
  const [isOpenSidebar, setIsOpenSidebar] = useState(true);
  const [isOpenProceduresPopup, setIsOpenProceduresPopup] = useState(false);

  return (
    <main className="bg-[#262d44] h-screen flex flex-col overflow-hidden">
      <Header>
        <h1 className="text-white text-[19px] font-medium montserrat-font ">
          Line Up
        </h1>
      </Header>

      <div className="flex-1 flex flex-col overflow-hidden ">
        <ResizablePanel
          direction="horizontal"
          initialSize={280} // Adjust width when collapsed
          minSize={180}
          maxSize={400}
          isShowSidebar={isOpenSidebar}
          panelContent={
            <div className="flex flex-col bg-[#F1F1F1] text-[#242424] h-full ">
              {/* Header Section */}
              <div className="flex items-center justify-between py-[5px] px-2.5 bg-white">
                <h6 className="text-[#242424] text-[12px] font-bold">라인업</h6>
                <button
                  className="w-6 aspect-square flex items-center justify-center"
                  onClick={() => setIsOpenSidebar(!isOpenSidebar)}
                >
                  {isOpenSidebar ? <SidebarCloseIcon /> : <SidebarOpenIcon />}
                </button>
              </div>

              {/* Sidebar Content */}
              {isOpenSidebar ? (
                <div className="flex-1 flex flex-col justify-between overflow-hidden transition-all duration-300">
                  <div className="custom-scrollbar flex-1 overflow-y-auto ">
                    <LineupSidebar
                      setIsOpenProceduresPopup={setIsOpenProceduresPopup}
                    />
                  </div>

                  {/* Footer */}

                  <div className="bg-white p-3 pr-4 flex items-center  gap-4 justify-between flex-wrap">
                    <p className="text-[#242424] text-[12px] font-normal">
                      ON/OFF
                    </p>
                    <div className="flex items-center flex-wrap gap-[14px]">
                      {["구조물", "계통", "방향키"].map((it, idx) => (
                        <div key={idx} className="flex items-center gap-1.5">
                          <Checkbox
                            color="#08F"
                            borderColor="border-[#242424]"
                          />
                          <span className="text-[#242424] text-[11px] font-light whitespace-nowrap">
                            {it}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          }
        >
          {/* Main Content */}
          <div className="flex flex-col h-full">
            <LineupContent />
          </div>
        </ResizablePanel>
      </div>

      {/* search Result popup  */}
      <AnimatedPopup
        label="절차서"
        subLabel="[999429] OH-526-01 SN2_526_M_TA01"
        isOpen={isOpenProceduresPopup}
        onClose={() => setIsOpenProceduresPopup(false)}
        className="max-w-[838px]"
        icon={articleWhite}
      >
        <ProceduresPopup />
      </AnimatedPopup>
    </main>
  );
}
